import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  from: z.enum(["generation", "review"]).optional(),
  slot: z.string().optional(),
  tab: z.enum(["rendered", "eval", "comments", "regen"]).optional(),
});

export const Route = createFileRoute("/draft-experiments/$id/variants/$variantId/edit")({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    const mode = search.from === "review" ? "review" : "generation";
    const tab = search.tab;
    if (mode === "review") {
      if (tab) {
        // oxlint-disable-next-line typescript-eslint/only-throw-error: TanStack Router requires throwing redirect objects
        throw redirect({
          to: "/draft-experiments/$id/review/variants/$variantId/$tab",
          params: { id: params.id, variantId: params.variantId, tab },
          replace: true,
        });
      }
      // oxlint-disable-next-line typescript-eslint/only-throw-error: TanStack Router requires throwing redirect objects
      throw redirect({
        to: "/draft-experiments/$id/review/variants/$variantId",
        params: { id: params.id, variantId: params.variantId },
        replace: true,
      });
    }
    if (tab) {
      // oxlint-disable-next-line typescript-eslint/only-throw-error: TanStack Router requires throwing redirect objects
      throw redirect({
        to: "/draft-experiments/$id/generation/variants/$variantId/$tab",
        params: { id: params.id, variantId: params.variantId, tab },
        replace: true,
      });
    }
    // oxlint-disable-next-line typescript-eslint/only-throw-error: TanStack Router requires throwing redirect objects
    throw redirect({
      to: "/draft-experiments/$id/generation/variants/$variantId",
      params: { id: params.id, variantId: params.variantId },
      replace: true,
    });
  },
});
